import * as React from "react";

// // // //

/**
 * DashboardPageUnlockGate
 * Temporary testing gate: renders children only on the client, and only when the
 * current URL has `?gated=true`. Used to enable page unlock gating on individual
 * pages for testing. Remove before the feature is released to everyone.
 */
export function DashboardPageUnlockGate(props: { children: React.ReactNode }) {
    const [isGated, setIsGated] = React.useState(false);

    React.useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        setIsGated(params.get("gated") === "true");
    }, []);

    if (!isGated) return null;
    return <>{props.children}</>;
}
